import { render } from "./app-icon-small-logo.vue?vue&type=template&id=20ada21c"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-small-logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20ada21c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20ada21c', __exports__)) {
    console.log('reload')
    api.reload('20ada21c', __exports__)
  }
  
  module.hot.accept("./app-icon-small-logo.vue?vue&type=template&id=20ada21c", () => {
    console.log('re-render')
    api.rerender('20ada21c', render)
  })

}


export default __exports__